var cov_194q3rl76z = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/uid.ts",
      hash = "b7884478e5252d48356ecf5260969cbb2fd69026",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/uid.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 31
        }
      },
      "1": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 28
        }
      },
      "2": {
        start: {
          line: 10,
          column: 20
        },
        end: {
          line: 10,
          column: 28
        }
      },
      "3": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 44
        }
      },
      "4": {
        start: {
          line: 11,
          column: 31
        },
        end: {
          line: 11,
          column: 44
        }
      },
      "5": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 53
        }
      },
      "6": {
        start: {
          line: 12,
          column: 33
        },
        end: {
          line: 12,
          column: 53
        }
      },
      "7": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 14
        }
      },
      "8": {
        start: {
          line: 18,
          column: 14
        },
        end: {
          line: 18,
          column: 49
        }
      },
      "9": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "10": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 94
        }
      },
      "11": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 12
        }
      },
      "12": {
        start: {
          line: 26,
          column: 21
        },
        end: {
          line: 26,
          column: 112
        }
      }
    },
    fnMap: {
      "0": {
        name: "getUidStr",
        decl: {
          start: {
            line: 4,
            column: 16
          },
          end: {
            line: 4,
            column: 25
          }
        },
        loc: {
          start: {
            line: 4,
            column: 63
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "$getKey",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 16
          }
        },
        loc: {
          start: {
            line: 9,
            column: 74
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 9
      },
      "2": {
        name: "getKey",
        decl: {
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 17,
            column: 22
          }
        },
        loc: {
          start: {
            line: 17,
            column: 76
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 17
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 28
          }
        }, {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 28
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 44
          }
        }, {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 44
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 53
          }
        }, {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 53
          }
        }],
        line: 12
      },
      "3": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }],
        line: 19
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 19,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 19,
            column: 29
          }
        }, {
          start: {
            line: 19,
            column: 33
          },
          end: {
            line: 19,
            column: 56
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 26,
            column: 21
          },
          end: {
            line: 26,
            column: 112
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 53
          },
          end: {
            line: 26,
            column: 99
          }
        }, {
          start: {
            line: 26,
            column: 102
          },
          end: {
            line: 26,
            column: 112
          }
        }],
        line: 26
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { v4 as getUUid } from 'uuid';
export function getUidStr() {
  cov_194q3rl76z.f[0]++;
  cov_194q3rl76z.s[0]++;
  // dom id  cannot start with number
  return "a".concat(getUUid.apply(void 0, arguments));
}

function $getKey(d, gen, index) {
  cov_194q3rl76z.f[1]++;
  cov_194q3rl76z.s[1]++;

  if (gen === true) {
    cov_194q3rl76z.b[0][0]++;
    cov_194q3rl76z.s[2]++;
    return d;
  } else {
    cov_194q3rl76z.b[0][1]++;
  }

  cov_194q3rl76z.s[3]++;

  if (typeof gen === 'string') {
    cov_194q3rl76z.b[1][0]++;
    cov_194q3rl76z.s[4]++;
    return d[gen];
  } else {
    cov_194q3rl76z.b[1][1]++;
  }

  cov_194q3rl76z.s[5]++;

  if (typeof gen === 'function') {
    cov_194q3rl76z.b[2][0]++;
    cov_194q3rl76z.s[6]++;
    return gen(d, index);
  } else {
    cov_194q3rl76z.b[2][1]++;
  }

  cov_194q3rl76z.s[7]++;
  return index;
}

export function getKey() {
  cov_194q3rl76z.f[2]++;
  var key = (cov_194q3rl76z.s[8]++, $getKey.apply(void 0, arguments));
  cov_194q3rl76z.s[9]++;

  if ((cov_194q3rl76z.b[4][0]++, typeof key !== 'string') && (cov_194q3rl76z.b[4][1]++, typeof key !== 'number')) {
    cov_194q3rl76z.b[3][0]++;
    cov_194q3rl76z.s[10]++;
    console.error(new Error("keygen result expect a string or a number, get '".concat(typeof key, "'")));
  } else {
    cov_194q3rl76z.b[3][1]++;
  }

  cov_194q3rl76z.s[11]++;
  return key;
}
export var defer = (cov_194q3rl76z.s[12]++, typeof Promise === 'function' ? (cov_194q3rl76z.b[5][0]++, Promise.resolve().then.bind(Promise.resolve())) : (cov_194q3rl76z.b[5][1]++, setTimeout));